import { cloudFunction } from '../parse';

export const addShoppingList = async (params: {name: string; isPublic: boolean; isFeatured: boolean}) => {
  return cloudFunction('addShoppingList', params);
};

export const addItemToShoppingList = async (
  inventoryItemId: string,
  shoppingListId: string,
) => {
  return cloudFunction('addItemToShoppingList', {
    inventoryItemId,
    shoppingListId,
  });
};

export const getShoppingListDetails = async (id: string) => {
  return cloudFunction('getShoppingListDetails', { id });
};

export const removeItemFromShoppingList = async (
  inventoryItemId: string,
  shoppingListId: string,
) => {
  return cloudFunction('removeItemFromShoppingList', {
    inventoryItemId,
    shoppingListId,
  });
};

export const removeShoppingList = async (id: string) => {
  return cloudFunction('removeShoppingList', { id });
};

export const updateShoppingList = async (params: {
  name: string;
  id: string;
  isPublic?: boolean;
  isFeatured?: boolean;
}) => {
  return cloudFunction('updateShoppingList', params);
};

export const fetchPublicShoppingList = async (params: any) => {
  return cloudFunction('fetchPublicShoppingList', params);
};

export const fetchAllShoppingLists = async (params: any) => {
  return cloudFunction('fetchAllShoppingList', params);
};